import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e82f5438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom" }
const _hoisted_2 = { class: "bottom-tp-ewm-img bottom-tp-ewm-one" }
const _hoisted_3 = { class: "bottom-tp-ewm-pig" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-tp-ewm-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "社区美居俱乐部"),
  /*#__PURE__*/_createElementVNode("div", null, "公众号")
], -1))
const _hoisted_5 = { class: "bottom-tp-ewm-img" }
const _hoisted_6 = { class: "bottom-tp-ewm-pig" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-tp-ewm-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "业务联系人"),
  /*#__PURE__*/_createElementVNode("div", null, "微信")
], -1))
const _hoisted_8 = { class: "bottom-tp-line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-tp-item" }, "公司名称：广州冠盟社区美居科技服务有限公司", -1))
const _hoisted_10 = { class: "bottom-tp-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("公司地址：")
const _hoisted_12 = { class: "bottom-tp-item-link" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("广州市南沙区天耀二街4号3003室")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-tp-item",
  style: {"display":"none"}
}, "联系电话：020-12345678", -1))
const _hoisted_15 = { class: "bottom-tp-line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-tp-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/frontDesk/about",
    style: {"color":"#FFFFFF"}
  }, "关于我们")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-tp-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/frontDesk/member",
    style: {"color":"#FFFFFF"}
  }, "成为俱乐部会员")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-tp-item" }, "招贤纳士", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "© 广州冠盟社区美居科技服务有限公司 版权所有", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"#FFFFFF"},
    href: "https://beian.miit.gov.cn",
    target: "_blank"
  }, "粤ICP备2022080366号")
], -1))

import router from "@/router/index";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const goToAbout = (hash: any) => {
  router.push("/frontDesk/about");
  setTimeout(function () {
    const goToHash = document.getElementById(hash);
    if (goToHash) {
      goToHash.scrollIntoView();
    }
  }, 1500);
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_location = _resolveComponent("location")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "bottom-tp" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_container, { class: "bottom-tp-ewm" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_image, {
                  class: "news-list-item-lt-banner",
                  src: require('@/assets/fd/u205.jpg')
                }, null, 8, ["src"])
              ]),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_image, {
                  class: "news-list-item-lt-banner",
                  src: require('@/assets/fd/u212.jpg')
                }, null, 8, ["src"])
              ]),
              _hoisted_7
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_icon, { style: {"margin-left":"5px","font-size":"18px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_location)
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", {
            class: "bottom-tp-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToAbout('scope-of-service')))
          }, "业务范围"),
          _hoisted_17,
          _hoisted_18
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, { class: "bottom-bt" }, {
      default: _withCtx(() => [
        _hoisted_19,
        _hoisted_20
      ]),
      _: 1
    })
  ]))
}
}

})